import { API_BASE_URL } from '../../../lib/api';
import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '@/lib/tenantHeaders';

/**
 * Instrucciones de embarque LCL.
 *
 * Los headers se construyen dentro de cada función: hacerlo al importar
 * congela el token y el slug del tenant de la primera carga.
 */
const jsonHeaders = () => withTenant({ 'Content-Type': 'application/json' });
const base = (lclRequestId) => `${API_BASE_URL}/lcl-instrucciones/by-request/${lclRequestId}`;

/**
 * Las guardadas o un borrador prellenado, más el contexto: cotización
 * seleccionada, proveedor, destinatarios sugeridos y si se puede notificar.
 */
export async function getInstrucciones(lclRequestId) {
  const res = await apiFetch(base(lclRequestId), { headers: withTenant() });
  return res.json();
}

export async function guardarInstrucciones(lclRequestId, payload) {
  const res = await apiFetch(base(lclRequestId), {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  return res.json();
}

/**
 * Manda las instrucciones al proveedor. `instrucciones` es lo que está en
 * pantalla: el servidor lo guarda antes de generar el PDF.
 */
export async function notificarProveedor(lclRequestId, payload) {
  const res = await apiFetch(`${base(lclRequestId)}/notificar`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  return res.json();
}

/**
 * PDF como object URL para el `<iframe>` de la vista previa.
 *
 * No se le puede dar la URL directa al iframe: el navegador la pide sin
 * el header `X-Tenant` y el backend no sabe de qué operador es. El
 * llamador DEBE liberarla con `URL.revokeObjectURL`.
 */
export async function fetchPreviewInstruccionesUrl(lclRequestId) {
  const res = await apiFetch(`${base(lclRequestId)}/pdf/preview`, { headers: withTenant() });
  if (!res.ok) {
    let msg = 'No se pudo generar la vista previa';
    try {
      msg = (await res.json())?.message || msg;
    } catch {
      /* la respuesta de error puede no ser JSON */
    }
    throw new Error(msg);
  }
  return URL.createObjectURL(await res.blob());
}
